import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e885816")

_pushScopeId("data-v-2e885816")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "grid grid-cols-10" }, [
  /*#__PURE__*/_createVNode("div", { class: "mb-2 xl:mb-0 col-span-10 lg:col-span-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "rounded-md bg-secondary h-6 w-40" })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-span-10 lg:col-span-6 md:flex lg:justify-end" }, [
    /*#__PURE__*/_createVNode("div", { class: "flex items-center lg:justify-end mb-2 md:mb-0" }, [
      /*#__PURE__*/_createVNode("div", { class: "rounded-md bg-secondary-light h-6 w-24 mr-5" }),
      /*#__PURE__*/_createVNode("div", { class: "rounded-md bg-secondary-light h-6 w-24 mr-5" }),
      /*#__PURE__*/_createVNode("div", { class: "rounded-md bg-secondary-light h-6 w-24 mr-5" })
    ]),
    /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-start lg:justify-end" }, [
      /*#__PURE__*/_createVNode("div", { class: "rounded-md bg-secondary-light h-6 w-8" }),
      /*#__PURE__*/_createVNode("div", { class: "rounded-md bg-secondary-light h-6 w-8 ml-2" }),
      /*#__PURE__*/_createVNode("div", { class: "rounded-md bg-secondary-light h-6 w-40 ml-2" })
    ])
  ])
], -1)
const _hoisted_2 = { class: "min-w-full mt-3" }
const _hoisted_3 = { class: "sceleton-masonry-with-columns" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "h-full bg-secondary-light rounded-md shine" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseCard = _resolveComponent("BaseCard")

  return (_openBlock(), _createBlock(_component_BaseCard, { class: "sceleton relative overflow-hidden sceleton-grid py-3 min-w-full" }, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceletonCards, (card, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "column"
            }, [
              _createVNode("div", {
                style: `height: ${card}px`,
                class: "py-1"
              }, [
                _hoisted_4
              ], 4)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
})